import { Link } from '@mui/material';

export function showDuplicateInvoiceSnackbar(rawMessage, { enqueueSnackbar, addTab, navigate }) {
  const match = rawMessage.match(/\[Duplicate ID: (\d+)]/);
  const duplicateInvoiceId = match ? match[1] : null;
  const messageWithoutId = rawMessage.replace(/\[Duplicate ID: \d+\]/, '');

  enqueueSnackbar(
    <span>
      <Link
        color="#fff"
        sx={{ textDecoration: 'underline' }}
        onClick={() => {
          if (duplicateInvoiceId) {
            addTab();
            navigate(`/dashboard/invoicing/previous/${duplicateInvoiceId}`);
          }
        }}
      >
        {messageWithoutId}
      </Link>
    </span>,
    { variant: 'error', persist: true }
  );
}